export default __webpack_public_path__ + "static/media/permission_icon.5fa2c8aa.svg";